/**
 * Diretiva responsável por criar um botão de copiar conteúdo para área de transferência. 
 */

angular.module("avlib").directive("avClipboardBtn", function(){
	return {
		template: '<a class="av-clipboard-btn"\
							ng-if="source"\
							href=""\
							ng-click="copyButtonClicked($event)"\
							av-tooltip="Copiar para área de transferência">\
						<i class="fa fa-clone"></i>\
					</a>',
		restrict: "E",
		scope: {
			source: "=",
		},
		
		controller: ["$scope", "clipboard", function($scope, clipboard){
			$scope.copyButtonClicked = function(event){
				var copyBtn = $(event.currentTarget);
				copyBtn.tooltip("hide");
				clipboard.copyText($scope.source);
				copyBtn.attr('data-original-title', 'Copiado!').tooltip('fixTitle');
				setTimeout(function(){
					copyBtn.tooltip("show");
					setTimeout(function(){
						copyBtn.tooltip("hide");
						copyBtn.attr('data-original-title', 'Copiar para área de transferência').tooltip('fixTitle');
					}, 1000);
				}, 200);
			};
		}],
	};
});
